import React from 'react';
import { PortfolioHeader } from '../components/PortfolioHeader';
import { ExpertiseRadar } from '../components/RadarChart';
import { CompetencyGrid } from '../components/CompetencyGrid';
export function Portfolio() {
  return <div className="min-h-screen bg-background text-foreground font-sans" data-id="element-70">
      <PortfolioHeader data-id="element-71" />

      <main className="container mx-auto px-4 py-16 space-y-20" data-id="element-72">
        {/* Expertise Visualization Section */}
        <section className="max-w-4xl mx-auto" data-id="element-73">
          <div className="text-center mb-10" data-id="element-74">
            <h2 className="text-3xl font-bold mb-4" data-id="element-75">Expertise Overview</h2>
            <p className="text-muted-foreground" data-id="element-76">
              A balanced mix of offensive security, defensive strategy, and
              product leadership.
            </p>
          </div>
          <div className="bg-card rounded-xl border shadow-sm p-6 md:p-10" data-id="element-77">
            <ExpertiseRadar data-id="element-78" />
          </div>
        </section>

        {/* Core Competencies Grid Section */}
        <section className="max-w-5xl mx-auto" data-id="element-79">
          <div className="text-center mb-12" data-id="element-80">
            <h2 className="text-3xl font-bold mb-4" data-id="element-81">Core Competencies</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto" data-id="element-82">
              Deep dive into my technical capabilities and strategic
              achievements. Click on any card to explore projects, tools, and
              results.
            </p>
          </div>
          <CompetencyGrid data-id="element-83" />
        </section>

        {/* Footer */}
        <footer className="text-center text-sm text-muted-foreground pt-10 border-t" data-id="element-84">
          <p data-id="element-85">
            © {new Date().getFullYear()} Aditya Khurana. Built with React &
            Tailwind CSS.
          </p>
        </footer>
      </main>
    </div>;
}